import * as AppConstants from '@/modules/core/constants/app.constants'

export const LOGIN_COUNT = `${AppConstants.DOMAIN}.login_count`
export const ACCESS_TOKEN = `${AppConstants.DOMAIN}.access_token`
